import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';
import * as adminStyles from '../AdminStyles.css';
import * as Constants from "../../Constants";
import { IADropDown } from '../../../dropDown/DropDown';
import { IATextField } from '../../../textField/TextField';
import { IAToggle } from '../../../toggle/Toggle';
import { IAIcon } from '../../../icon/Icon';
import { Environment } from '../../../../services/Environment';
import { Utils } from '../Utils';
import { TreeTargeting } from '../../../treeTargeting/TreeTargeting';
import { ITargetingApplications } from '../../../../interfaces/ITargetingApplications';
import TargetingUtils from '../../../treeTargeting/utils';
import { LocalizationService } from '../../../../services/LocalizationService';
import { Helper } from '../../../../Helper';
import { IAIconPicker } from '../../../iconPicker/IconPicker';
import { IAEditor } from '../../../editor/Index';
import { IAMediaSelector } from '../../../mediaSelector/MediaSelector';
import { TreeTargetingForGroups } from '../../../treeTargetingForGroups';

export interface IElementSettingsPanelProps {
  navigatorStore?: NavigatorStore;
}

export interface IElementSettingsPanelState {
  applicationSettings?: ITargetingApplications;
}

@inject('navigatorStore')
@observer
export default class ElementSettingsPanel extends React.Component<IElementSettingsPanelProps, IElementSettingsPanelState> {

  private selectedValues: Array<any>;

  constructor(props: IElementSettingsPanelProps) {
    super(props);
    this.state = {
      applicationSettings: null,
    };
  }

  public render(): JSX.Element {
    if (this.props.navigatorStore.isShowingElementSettings && this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit] != undefined) {
      let selectedElement = this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit].elementGroups ? this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit].elementGroups[this.props.navigatorStore.elementGroupColumnIndexToEdit][this.props.navigatorStore.elementGroupIndexToEdit].elements[this.props.navigatorStore.elementIndexToEdit] : undefined;
      if (selectedElement != undefined && selectedElement.targeting != undefined && this.props.navigatorStore.applicationSettings) {
        this.selectedValues = Utils.parseSelectedTargetingValues(selectedElement.targeting, this.props.navigatorStore.applicationSettings?.applicationSettings);
      }
      let showOpenInNewWindowSetting;
      if (selectedElement != undefined) {
        showOpenInNewWindowSetting = selectedElement.type == "link" || selectedElement.type == "image";
      }
      // Checking if targeting is enabled
      const showTargetOptions = TargetingUtils.checkIfUsesTargeting(this.props.navigatorStore.applicationSettings, this.props.navigatorStore.instance);
      console.log(this.props.navigatorStore.hasChanged);
      let top = 51;
      switch (Helper.getDisplayEnvironment()) {
        case "ExternalEnvironment":
          top = 51;
          break;
        case "Sharepoint":
          top = 169;
          break;
      }
      return (
        <div
          className={adminStyles.panel}
          style={{
            right: this.props.navigatorStore.isShowingElementSettings ? "0px" : "-400px",
            top: top,
            height: `calc(100% - ${top}px)`,
            overflowY: "auto"
          }}
        >
          <div className={adminStyles.panelHeader}>
            {new LocalizationService().strings.Navigator_Settings_Element}
            <IAIcon
              title={"Close"}
              size={20}
              color="#ffffff"
              onClick={() => {
                this.props.navigatorStore.toggleElementSettings();
              }}
              style={{
                float: "right",
                padding: "5px 10px",
                cursor: "pointer"
              }}
            />
          </div>
          <div className={adminStyles.content}>
            <div>
              <IADropDown
                label={new LocalizationService().strings.Navigator_Content_ElementType}
                selectedOption={this.props.navigatorStore.elementIndexToEdit != undefined && selectedElement != undefined ? selectedElement.type : undefined}
                options={Constants.ELEMENT_TYPES}
                onChange={(type: string) => {
                  if (type) {
                    this.props.navigatorStore.setElementType(type.toLowerCase());
                    this.forceUpdate();
                  }
                }}
              />
              <div className={adminStyles.panelDivider} />
              {selectedElement != undefined && selectedElement.type == "link" &&
                <IATextField
                  label={new LocalizationService().strings.Navigator_Content_Titel}
                  text={selectedElement.config.text}
                  onChange={(text: string) => this.props.navigatorStore.setElementTitle(text)}
                />
              }
              {selectedElement != undefined && selectedElement.type == "image" &&
                <>
                  <IAMediaSelector
                    label={new LocalizationService().strings.Navigator_Content_ElementImage}
                    showPreview={false}
                    fileType="image"
                    highlightColor={this.props.navigatorStore.navigator?.design?.menuBar?.highlightColor}
                    token={this.props.navigatorStore.token}
                    tenant={this.props.navigatorStore.tenant.substring(0, this.props.navigatorStore.tenant.indexOf('.'))}
                    selectedImage={selectedElement.config.imageUrl}
                    environment={this.props.navigatorStore.environment}
                    uploadUrl={`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/image?site=IntraActive-NavigatorAdmin&relativeUrl=${encodeURIComponent("lists/IANavigatorImages")}`}
                    onChange={(imageUrl: string) => {
                      this.props.navigatorStore.setElementImageUrl(imageUrl);
                      this.forceUpdate();
                    }}
                    style={{
                      clear: "both",
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <div className={adminStyles.panelDivider} />
                </>
              }
              {selectedElement != undefined && selectedElement.type !== "text" &&
                <IATextField
                  label={new LocalizationService().strings.Navigator_Content_Url}
                  text={selectedElement.config.url}
                  onChange={(url: string) => {
                    this.props.navigatorStore.setElementUrl(selectedElement.type === "video" ? Helper.convertUrlToEmbedUrl(url) : url);
                  }}
                />
              }
              {selectedElement != undefined && selectedElement.type === "text" &&
                <IAEditor
                  simple={false}
                  useImageAPI
                  uploadImagesToSharepoint
                  token={this.props.navigatorStore.token}
                  tenant={this.props.navigatorStore.tenant}
                  environment={this.props.navigatorStore.environment}
                  isMobile={this.props.navigatorStore.isMobile}
                  highlightColor={"#333333"}
                  content={selectedElement.config.content}
                  onChange={(content) => {
                    selectedElement.config.content = content;
                    this.props.navigatorStore.checkForChanges();
                  }}
                  onStyleChange={(style) => { console.log(style) }}
                  placeholder={"Type here"}
                  style={{
                    border: "1px solid #eeeeee",
                    padding: 5,
                    boxSizing: "border-box",
                    marginTop: 20,
                    width: "calc(100% - 10px)"
                  }}
                  fontSizeSupport
                  fontStyleSupport
                  textAlignmentSupport
                  textColorSupport
                  clearStylingSupport
                  emojiSupport
                  fontFamilySupport
                />
              }
              {selectedElement != undefined && showOpenInNewWindowSetting &&
                <IAToggle
                  label={new LocalizationService().strings.Navigator_Content_LinkOpen}
                  checked={selectedElement.config.openInNewWindow}
                  color={"#333333"}
                  onChange={() => {
                    this.props.navigatorStore.setElementOpenInNewWindow();
                    this.forceUpdate();
                  }}
                  style={{
                    marginTop: 20
                  }}
                />
              }

              {selectedElement != undefined && selectedElement.type == "link" &&
                <IAIconPicker
                  label={new LocalizationService().strings.Navigator_Content_Icon}
                  selectedIcon={selectedElement.config.icon}
                  color={"#333333"}
                  select={(icon: string) => {
                    this.props.navigatorStore.setElementIcon(icon);
                    this.forceUpdate();
                  }}
                  shouldBeAbleToClear={true}
                  clear={() => {
                    this.props.navigatorStore.setElementIcon(undefined);
                    this.forceUpdate();
                  }}
                />
              }
              <div className={adminStyles.panelDivider} />
              {selectedElement !== undefined && showTargetOptions &&
                <div style={{
                  marginTop: "20px", clear: "both", float: "left", width: "100%"
                }}>
                  {this.props.navigatorStore.applicationSettings?.applicationSettings?.toLowerCase() === "profile data" ?
                    <TreeTargeting
                      application={"navigator"}
                      environment={this.props.navigatorStore.environment}
                      applicationData={this.props.navigatorStore.applicationSettings}
                      instance={this.props.navigatorStore.instance}
                      tenant={this.props.navigatorStore.tenant}
                      authToken={this.props.navigatorStore.token}
                      apiUrl={Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}
                      selectedValues={this.selectedValues}
                      operator={selectedElement.targeting != null ? selectedElement.targeting.operator : "AND"}
                      showTarget={selectedElement.targeting != null ? selectedElement.targeting.enabled : false}
                      currenNodeStructure={selectedElement.targetingExistingStructure}
                      onShowTargetChanged={(showTarget: boolean) => {
                        if (!selectedElement.targeting) {
                          selectedElement.targeting = {
                            enabled: showTarget,
                            operator: "AND"
                          };
                        } else {
                          selectedElement.targeting.enabled = showTarget;
                        }
                        this.props.navigatorStore.checkForChanges();
                      }}
                      onChange={(targeting, applicationSettings, groups, _selectAll, targetingexistingstructure) => {

                        // Processing targeting values
                        if (targeting) {
                          selectedElement.targeting.targetingFields = Utils.processReturnTreeTargeting(targeting);
                        }

                        // Processing targeting group data
                        if (groups) {
                          selectedElement.targeting.groupData = JSON.stringify(groups);
                          selectedElement.targeting.targetingGroups = [];

                          if (groups.length > 0) {
                            groups.forEach((x) => {
                              selectedElement.targeting.targetingGroups.push(x.id.toString());
                            });
                          }
                        }

                        this.props.navigatorStore.applicationSettings = applicationSettings;
                        this.setState({ applicationSettings: applicationSettings });
                        selectedElement.targetingExistingStructure = targetingexistingstructure;
                        this.props.navigatorStore.checkForChanges();
                      }}
                      highlightColor={this.props.navigatorStore.adminColor}
                      onLogicalOperatorChanged={(operator: string) => {
                        selectedElement.targeting.operator = operator;
                      }}
                      nodeComparison={"label"}
                    />
                    :
                    <TreeTargetingForGroups
                      environment={this.props.navigatorStore.environment}
                      tenant={this.props.navigatorStore.tenant.replace(".sharepoint.com", "")}
                      application={"navigator"}
                      instance={this.props.navigatorStore.instance}
                      applicationData={this.props.navigatorStore.applicationSettings}
                      selectedGroupIds={this.selectedValues?.map((itemData) => itemData.id)}
                      highlightColor={this.props.navigatorStore.adminColor}
                      showTarget={selectedElement.targeting != null ? selectedElement.targeting.enabled : false}
                      onShowTargetChanged={(showTarget: boolean) => {
                        if (!selectedElement.targeting) {
                          selectedElement.targeting = {
                            enabled: showTarget,
                            operator: "AND"
                          };
                        } else {
                          selectedElement.targeting.enabled = showTarget;
                        }
                        this.props.navigatorStore.checkForChanges();
                      }}
                      onGroupIdsUpdated={(ids: number[]) => {
                        selectedElement.targeting.targetingGroups = ids;
                        this.props.navigatorStore.checkForChanges();
                      }}
                    />
                  }
                </div>
              }
              <div className={adminStyles.panelDivider} />
              {!this.props.navigatorStore.isCreatingContent &&
                <div
                  className={adminStyles.settingsPanelDeleteButton}
                  onClick={() => {
                    this.props.navigatorStore.deleteSelectedElement();
                  }}
                  style={{
                    backgroundColor: "#eeeeee"
                  }}
                >
                  <div
                    className={adminStyles.settingsPanelDeleteButtonIcon}
                  >
                    <IAIcon
                      title="Trash"
                      size={20}
                      color="#333333"
                    />
                  </div>
                  <div
                    className={adminStyles.settingsPanelDeleteButtonText}
                    style={{
                      color: "#333333"
                    }}
                  >
                    {new LocalizationService().strings.Navigator_ElementPanel_Delete}
                  </div>
                </div>
              }
              <div
                className={adminStyles.settingsPanelDeleteButton}
                onClick={() => {
                  if (localStorage.getItem(`navigator-${this.props.navigatorStore.instanceId}`) != undefined && !this.props.navigatorStore.isCreatingContent) {
                    let originalNavigator = JSON.parse(localStorage.getItem(`navigator-${this.props.navigatorStore.instanceId}`));
                    this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit].elementGroups[this.props.navigatorStore.elementGroupColumnIndexToEdit][this.props.navigatorStore.elementGroupIndexToEdit].elements[this.props.navigatorStore.elementIndexToEdit] = originalNavigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit].elementGroups[this.props.navigatorStore.elementGroupColumnIndexToEdit][this.props.navigatorStore.elementGroupIndexToEdit].elements[this.props.navigatorStore.elementIndexToEdit];
                    this.props.navigatorStore.toggleElementSettings();
                  }
                  if (this.props.navigatorStore.isCreatingContent) {
                    this.props.navigatorStore.deleteSelectedElement();
                  }
                }}
                style={{
                  backgroundColor: "#eeeeee"
                }}
              >
                <div className={adminStyles.settingsPanelDeleteButtonText}>
                  {new LocalizationService().strings.Navigator_ElementPanel_Cancel}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (<div></div>);
    }
  }
}